<template>
  <div>
    <create-notifications />
  </div>
</template>

<script>
import CreateNotifications from '../../components/access/CreateNotifications';

export default {
  name: "templates",
  components: {
    CreateNotifications,
  },
};
</script>

<style scoped>
</style>